module.exports = __webpack_public_path__ + "img/3.ace49bca.png";